namespace TabAurous.OMS {
    export interface HSNTaxDetailsForm {
        Code: Serenity.StringEditor;
        TaxId: Serenity.IntegerEditor;
        TaxRate: Serenity.DecimalEditor;
        IsInterState: _Ext.YesNoEditor;
    }

    export class HSNTaxDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.HSNTaxDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!HSNTaxDetailsForm.init)  {
                HSNTaxDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;
                var w3 = _Ext.YesNoEditor;

                Q.initFormType(HSNTaxDetailsForm, [
                    'Code', w0,
                    'TaxId', w1,
                    'TaxRate', w2,
                    'IsInterState', w3
                ]);
            }
        }
    }
}
